import { createContext, useContext } from 'react';

const BurgerMenuContext = createContext({
  closeMenu: () => {},
});

export const useBurgerMenu = () => useContext(BurgerMenuContext);

export default BurgerMenuContext;
